const gender = {
    VAL: {
        MALE: 1,
        FEMALE: 2,
        OTHER: 3,
    },
    NAME: {
        MALE: '男性',
        FEMALE: '女性',
        OTHER: 'その他',
    },
    LIST: [],
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    }
};
gender.LIST.push({ value: gender.VAL.MALE, text: gender.NAME.MALE });
gender.LIST.push({ value: gender.VAL.FEMALE, text: gender.NAME.FEMALE });
//gender.LIST.push({ value: gender.VAL.OTHER, text: gender.NAME.OTHER });

const bloodType = {
    VAL: {
        A: 1,
        B: 2,
        O: 3,
        AB: 4,
        OTHER: 10,
    },
    NAME: {
        A: "A",
        B: "B",
        O: "O",
        AB: "AB",
        OTHER: "不明",
    },
    LIST: [
        { value: 1, text: "A" },
        { value: 2, text: "B" },
        { value: 3, text: "O" },
        { value: 4, text: "AB" },
        { value: 10, text: "不明" },
    ],
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "不明";
        return type.text;
    }
};

const finalEducation = {
    VAL: {
        NONE: 0,
        UNIVERSITY: 1,
        JUNIOUR_COLLEGE: 2,
        CAREER_COLLEGE: 3,
        HIGH_SCHOOL: 4,
        JUNIOUR_HIGH: 5,
    },
    NAME: {
        NONE: "未回答",
        UNIVERSITY: "大学",
        JUNIOUR_COLLEGE: "短大",
        CAREER_COLLEGE: "専門",
        HIGH_SCHOOL: "高校",
        JUNIOUR_HIGH: "中学",
    },
    LIST: [],
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    }
};
finalEducation.LIST.push({ value: finalEducation.VAL.NONE, text: finalEducation.NAME.NONE });
finalEducation.LIST.push({ value: finalEducation.VAL.UNIVERSITY, text: finalEducation.NAME.UNIVERSITY });
finalEducation.LIST.push({ value: finalEducation.VAL.JUNIOUR_COLLEGE, text: finalEducation.NAME.JUNIOUR_COLLEGE });
finalEducation.LIST.push({ value: finalEducation.VAL.CAREER_COLLEGE, text: finalEducation.NAME.CAREER_COLLEGE });
finalEducation.LIST.push({ value: finalEducation.VAL.HIGH_SCHOOL, text: finalEducation.NAME.HIGH_SCHOOL });
finalEducation.LIST.push({ value: finalEducation.VAL.JUNIOUR_HIGH, text: finalEducation.NAME.JUNIOUR_HIGH });

const execKind = {
    VAL: {
        TO_CALL: 1,
        FROM_CALL: 2,
        OK_CALL: 3,
        NG_CALL: 4,
        AUTO_CALL: 1017,
        SHOP_COUNSELING: 11,
        REMOTE_COUNSELING: 12,
        VISIT_COUNSELING: 13,
        COUNSELING: 14,
        MATCHING_1: 21,
        MATCHING_2: 22,
        MATCHING_3: 23,
        MATCHING: 24,
        CS_MATCHING: 26,
        DATE: 31,
        DATE2: 32,
        DATE3: 33,
        OTHER: 51,
        CONTRACT: 101,
        SHIFT_CONTRACT: 102,
        SELECT_MATCH: 111,
        COUNSELING_1: 121,
        COUNSELING_2: 122,
        COUNSELING_3: 123,
        COUNSELING_SALES: 131,
        WOMAN_FIRST: 201,
        WAIT_MATCHING: 301,
        NONFULFILLMENT_MATCHING: 302,
        REFUSE_MATCHING: 303,
        SIMULATION: 401,
        ADVISE: 501,
        FEMALE_MEMBERSHIP: 9999,
        COMING_WORK_AFTER_MARRIAGE: 1000,
        USAGE_PROHIBITED: 1001,
        AHEAD_SHIFT_CO: 1002, //TODO
        THIS_SHIFT_CO: 1016, //TODO
        MATCHMAKING_SIMULATION: 1003, //TODO
        DATE_SIMULATION: 1004, //TODO
        OTHER_BRANCH_DATE: 1005, //TODO
        OTHER_BRANCH_MATCHMAKING: 1006, //TODO
        VISIT_TO_REPORT: 1007, //TODO
        EMAIL: 1008,
        RECEIVE_EMAIL: 1009,
        START_DATING: 1010,
        RELATIONSHIP_BREAK: 1011,
        MARRIAGE: 1012,
        MINI_TEA_CONTAINER: 1013,
        EVENT: 1014,
        SEMINAR: 1015,
        SOLO_INTRODUCTION: 1018,
    },
    NAME: {
        TO_CALL: "TELする",
        FROM_CALL: "TEL受ける",
        OK_CALL: "OKTEL",
        NG_CALL: "断TEL",
        AUTO_CALL: "TELする（留守電）",
        SHOP_COUNSELING: "来社CO",
        REMOTE_COUNSELING: "ズームCO",
        VISIT_COUNSELING: "訪問",
        COUNSELING: "カウンセリング",
        MATCHING_1: "見愛1回目",
        MATCHING_2: "見愛2回目",
        MATCHING_3: "見愛3回目以降",
        MATCHING: "お見合い",
        CS_MATCHING: "連盟見合",
        DATE: "デート①",
        DATE2: "デート②",
        DATE3: "デート③",
        OTHER: "その他",
        CONTRACT: "入会",
        SHIFT_CONTRACT: "シフト入会",
        SELECT_MATCH: "お相手選び",
        //COUNSELING_1: "第1回CO",
        COUNSELING_1: "オリ①",
        COUNSELING_2: "第2回CO",
        COUNSELING_3: "第3回CO",
        COUNSELING_SALES: "CO営業",
        WOMAN_FIRST: "女性初回",
        WAIT_MATCHING: "見合待ち",
        NONFULFILLMENT_MATCHING: "見合不履行",
        REFUSE_MATCHING: "相手見合不履行",
        SIMULATION: "シミュレーション",
        ADVISE: "AD面談",
        FEMALE_MEMBERSHIP: "女性入会",
        COMING_WORK_AFTER_MARRIAGE: "成婚来社",
        USAGE_PROHIBITED: "使用不可",
        AHEAD_SHIFT_CO: '先シフトCO', //TODO
        THIS_SHIFT_CO: '当シフトCO', //TODO
        MATCHMAKING_SIMULATION: '見合ｼﾐｭﾚｰｼｮﾝ', //TODO
        DATE_SIMULATION: 'ﾃﾞｰﾄｼﾐｭﾚｰｼｮﾝ', //TODO
        OTHER_BRANCH_DATE: '他支店デート', //TODO
        OTHER_BRANCH_MATCHMAKING: '他支店見合', //TODO
        VISIT_TO_REPORT: '報告来社', //TODO
        EMAIL: 'メールする',
        RECEIVE_EMAIL: 'メール受ける',
        START_DATING: '交際開始',
        RELATIONSHIP_BREAK: '交際破断',
        MARRIAGE: '成婚',
        MINI_TEA_CONTAINER: 'ミニお茶コン',
        EVENT: 'イベント',
        SEMINAR: 'セミナー',
        SOLO_INTRODUCTION: 'お申込み紹介',
    },
    SHORT_NAME: {
        TO_CALL: "TELする",
        FROM_CALL: "TEL受ける",
        OK_CALL: "OKTEL",
        NG_CALL: "断TEL",
        AUTO_CALL: "TELする（留守電）",
        SHOP_COUNSELING: "来社CO",
        REMOTE_COUNSELING: "ｽﾞｰﾑCO",
        VISIT_COUNSELING: "訪問",
        COUNSELING: "ＣＯ",
        MATCHING_1: "見愛1回目",
        MATCHING_2: "見愛2回目",
        MATCHING_3: "見愛3回目以降",
        MATCHING: "見合",
        CS_MATCHING: "連盟見",
        DATE: "ﾃﾞｰﾄ1",
        DATE2: "ﾃﾞｰﾄ2",
        DATE3: "ﾃﾞｰﾄ3",
        OTHER: "その他",
        CONTRACT: "入会",
        SHIFT_CONTRACT: "シフト入会",
        SELECT_MATCH: "相手選",
        //COUNSELING_1: "第1回CO",
        COUNSELING_1: "オリ①",
        COUNSELING_2: "第2CO",
        COUNSELING_3: "第3CO",
        COUNSELING_SALES: "CO営業",
        WOMAN_FIRST: "女性初回",
        WAIT_MATCHING: "見合待ち",
        NONFULFILLMENT_MATCHING: "見合不履行",
        REFUSE_MATCHING: "相手見合不履行",
        SIMULATION: "シミュレーション",
        ADVISE: "AD面談",
        FEMALE_MEMBERSHIP: "女性入会",
        COMING_WORK_AFTER_MARRIAGE: "成婚来社",
        USAGE_PROHIBITED: "使用不可",
        AHEAD_SHIFT_CO: '先シフト',
        THIS_SHIFT_CO: '当シフト',
        MATCHMAKING_SIMULATION: '見合ｼﾐｭ',
        DATE_SIMULATION: 'ﾃﾞｰﾄｼﾐｭ',
        OTHER_BRANCH_DATE: '他店ﾃﾞｰﾄ',
        OTHER_BRANCH_MATCHMAKING: '他見合',
        VISIT_TO_REPORT: '報告来社',
        EMAIL: 'メールする',
        RECEIVE_EMAIL: 'メール受ける',
        START_DATING: '交際開始',
        RELATIONSHIP_BREAK: '交際破断',
        MARRIAGE: '成婚',
        MINI_TEA_CONTAINER: 'ミニお茶コン',
        EVENT: 'イベント',
        SEMINAR: 'セミナー',
        SOLO_INTRODUCTION: 'お申込み紹介'
    },
    LIST: [],
    LIST_SHORT_NAME: [],
    COLOR: {
        MATCHING: "orange",
        CS_MATCHING: "orange",
        DATE: "ﾃﾞｰﾄ",
        SELECT_MATCH: "cyan",
        VISIT_TO_REPORT: '報告来',
        COUNSELING_1: "オリ①",
        COUNSELING_2: "第2CO",
        COUNSELING_3: "第3CO",
        COUNSELING: "ＣＯ",
        REMOTE_COUNSELING: "ズームCO",
        MATCHMAKING_SIMULATION: '見合ｼﾐｭ',
        DATE_SIMULATION: 'ﾃﾞｰﾄｼﾐｭ',
        AHEAD_SHIFT_CO: '先シフト',
        THIS_SHIFT_CO: '当シフト',
        WOMAN_FIRST: "女性初回",
        ADVISE: "AD面談",
        USAGE_PROHIBITED: "使用不可",
        VISIT_COUNSELING: "訪問",
        EVENT: 'イベント',
        SOLO_INTRODUCTION: 'cyan',
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    },
    getShort(val) {
        const type = this.LIST_SHORT_NAME.find(v => v.value == val);
        if (!type) return "";
        return type.shortText;
    }
};
for (const [key, value] of Object.entries(execKind.SHORT_NAME)) {
    execKind.LIST_SHORT_NAME.push({ value: execKind.VAL[key], shortText: value, color: execKind.COLOR[key] })
}

execKind.LIST.push({ value: execKind.VAL.CONTRACT, text: execKind.NAME.CONTRACT });
execKind.LIST.push({ value: execKind.VAL.SHIFT_CONTRACT, text: execKind.NAME.SHIFT_CONTRACT });
execKind.LIST.push({ value: execKind.VAL.COUNSELING_1, text: execKind.NAME.COUNSELING_1 });
execKind.LIST.push({ value: execKind.VAL.COUNSELING_2, text: execKind.NAME.COUNSELING_2 });
execKind.LIST.push({ value: execKind.VAL.COUNSELING_3, text: execKind.NAME.COUNSELING_3 });
execKind.LIST.push({ value: execKind.VAL.COUNSELING, text: execKind.NAME.COUNSELING });
execKind.LIST.push({ value: execKind.VAL.SELECT_MATCH, text: execKind.NAME.SELECT_MATCH });
execKind.LIST.push({ value: execKind.VAL.SIMULATION, text: execKind.NAME.SIMULATION });
// execKind.LIST.push({ value: execKind.VAL.MATCHING_1, text: execKind.NAME.MATCHING_1 });
// execKind.LIST.push({ value: execKind.VAL.MATCHING_2, text: execKind.NAME.MATCHING_2 });
// execKind.LIST.push({ value: execKind.VAL.MATCHING_3, text: execKind.NAME.MATCHING_3 });
execKind.LIST.push({ value: execKind.VAL.MATCHING, text: execKind.NAME.MATCHING });
execKind.LIST.push({ value: execKind.VAL.CS_MATCHING, text: execKind.NAME.CS_MATCHING });

execKind.LIST.push({ value: execKind.VAL.WAIT_MATCHING, text: execKind.NAME.WAIT_MATCHING });
execKind.LIST.push({ value: execKind.VAL.NONFULFILLMENT_MATCHING, text: execKind.NAME.NONFULFILLMENT_MATCHING });
execKind.LIST.push({ value: execKind.VAL.REFUSE_MATCHING, text: execKind.NAME.REFUSE_MATCHING });

execKind.LIST.push({ value: execKind.VAL.DATE, text: execKind.NAME.DATE });
execKind.LIST.push({ value: execKind.VAL.DATE2, text: execKind.NAME.DATE2 });
execKind.LIST.push({ value: execKind.VAL.DATE3, text: execKind.NAME.DATE3 });

execKind.LIST.push({ value: execKind.VAL.COUNSELING_SALES, text: execKind.NAME.COUNSELING_SALES });
execKind.LIST.push({ value: execKind.VAL.TO_CALL, text: execKind.NAME.TO_CALL });
execKind.LIST.push({ value: execKind.VAL.FROM_CALL, text: execKind.NAME.FROM_CALL });
execKind.LIST.push({ value: execKind.VAL.OK_CALL, text: execKind.NAME.OK_CALL });
execKind.LIST.push({ value: execKind.VAL.NG_CALL, text: execKind.NAME.NG_CALL });
execKind.LIST.push({ value: execKind.VAL.AUTO_CALL, text: execKind.NAME.AUTO_CALL });
execKind.LIST.push({ value: execKind.VAL.OTHER, text: execKind.NAME.OTHER });
execKind.LIST.push({ value: execKind.VAL.WOMAN_FIRST, text: execKind.NAME.WOMAN_FIRST });
// execKind.LIST.push({ value: execKind.VAL.SHOP_COUNSELING, text: execKind.NAME.SHOP_COUNSELING });
execKind.LIST.push({ value: execKind.VAL.REMOTE_COUNSELING, text: execKind.NAME.REMOTE_COUNSELING });
execKind.LIST.push({ value: execKind.VAL.VISIT_COUNSELING, text: execKind.NAME.VISIT_COUNSELING });
execKind.LIST.push({ value: execKind.VAL.ADVISE, text: execKind.NAME.ADVISE });
execKind.LIST.push({ value: execKind.VAL.FEMALE_MEMBERSHIP, text: execKind.NAME.FEMALE_MEMBERSHIP });
execKind.LIST.push({ value: execKind.VAL.COMING_WORK_AFTER_MARRIAGE, text: execKind.NAME.COMING_WORK_AFTER_MARRIAGE });
execKind.LIST.push({ value: execKind.VAL.USAGE_PROHIBITED, text: execKind.NAME.USAGE_PROHIBITED });
execKind.LIST.push({ value: execKind.VAL.AHEAD_SHIFT_CO, text: execKind.NAME.AHEAD_SHIFT_CO });
execKind.LIST.push({ value: execKind.VAL.THIS_SHIFT_CO, text: execKind.NAME.THIS_SHIFT_CO });
execKind.LIST.push({ value: execKind.VAL.MATCHMAKING_SIMULATION, text: execKind.NAME.MATCHMAKING_SIMULATION });
execKind.LIST.push({ value: execKind.VAL.DATE_SIMULATION, text: execKind.NAME.DATE_SIMULATION });
execKind.LIST.push({ value: execKind.VAL.OTHER_BRANCH_DATE, text: execKind.NAME.OTHER_BRANCH_DATE });
execKind.LIST.push({ value: execKind.VAL.OTHER_BRANCH_MATCHMAKING, text: execKind.NAME.OTHER_BRANCH_MATCHMAKING });
execKind.LIST.push({ value: execKind.VAL.VISIT_TO_REPORT, text: execKind.NAME.VISIT_TO_REPORT });
execKind.LIST.push({ value: execKind.VAL.EMAIL, text: execKind.NAME.EMAIL });
execKind.LIST.push({ value: execKind.VAL.RECEIVE_EMAIL, text: execKind.NAME.RECEIVE_EMAIL });
execKind.LIST.push({ value: execKind.VAL.START_DATING, text: execKind.NAME.START_DATING });
execKind.LIST.push({ value: execKind.VAL.RELATIONSHIP_BREAK, text: execKind.NAME.RELATIONSHIP_BREAK });
execKind.LIST.push({ value: execKind.VAL.MARRIAGE, text: execKind.NAME.MARRIAGE });
execKind.LIST.push({ value: execKind.VAL.MINI_TEA_CONTAINER, text: execKind.NAME.MINI_TEA_CONTAINER });
execKind.LIST.push({ value: execKind.VAL.EVENT, text: execKind.NAME.EVENT });
execKind.LIST.push({ value: execKind.VAL.SEMINAR, text: execKind.NAME.SEMINAR });
execKind.LIST.push({ value: execKind.VAL.SOLO_INTRODUCTION, text: execKind.NAME.SOLO_INTRODUCTION });

const connectFlag = {
    VAL: {
        CONNECT: 1,
        IBJ: 2,
    },
    NAME: {
        CONNECT: 'コネクト見合',
        IBJ: 'IBJ見合',
    },
    LIST: [],
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    }
};
connectFlag.LIST.push({ value: connectFlag.VAL.IBJ, text: connectFlag.NAME.IBJ });
connectFlag.LIST.push({ value: connectFlag.VAL.CONNECT, text: connectFlag.NAME.CONNECT });

const exitReason = {
    VAL: {
        FULL: 1,
        HALF: 2,
        MARRIAGE: 3,
    },
    NAME: {
        FULL: '満期退会',
        HALF: '中途退会',
        MARRIAGE: '成婚退会',
    },
    LIST: [],
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    }
};
exitReason.LIST.push({ value: exitReason.VAL.FULL, text: exitReason.NAME.FULL });
exitReason.LIST.push({ value: exitReason.VAL.HALF, text: exitReason.NAME.HALF });
exitReason.LIST.push({ value: exitReason.VAL.MARRIAGE, text: exitReason.NAME.MARRIAGE });

const kinds = {
    NAME: {
        CONTRACT: "入会",
        COUNSELING_1: "オリ①",
        COUNSELING_2: "第2回CO",
        COUNSELING_3: "第3回CO",
        COUNSELING: "カウンセリング",
        REMOTE_COUNSELING: "ズームCO",
        SIMULATION: "シミュレーション",
        SHIFT_CONTRACT: "シフト入会",
        COUNSELING_SALES: "CO営業",
        COMING_WORK_AFTER_MARRIAGE: "成婚来社",
        WOMAN_FIRST: "女性初回",
        ADVISE: "AD面談",
        USAGE_PROHIBITED: "使用不可",
        AHEAD_SHIFT_CO: '先シフトCO', //TODO
        THIS_SHIFT_CO: '当シフトCO', //TODO
        MATCHMAKING_SIMULATION: '見合ｼﾐｭﾚｰｼｮﾝ', //TODO
        DATE_SIMULATION: 'ﾃﾞｰﾄｼﾐｭﾚｰｼｮﾝ', //TODO
    },
    VAL: {
        CONTRACT: 101,
        COUNSELING_1: 121,
        COUNSELING_2: 122,
        COUNSELING_3: 123,
        COUNSELING: 14,
        REMOTE_COUNSELING: 12,
        SIMULATION: 401,
        SHIFT_CONTRACT: 102,
        COUNSELING_SALES: 131,
        COMING_WORK_AFTER_MARRIAGE: 1000, //TODO
        WOMAN_FIRST: 201,
        ADVISE: 501,
        USAGE_PROHIBITED: 1001, //TODO
        AHEAD_SHIFT_CO: 1002, //TODO
        THIS_SHIFT_CO: 1016, //TODO
        MATCHMAKING_SIMULATION: 1003, //TODO
        DATE_SIMULATION: 1004, //TODO
    },
    LIST: [],
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    }
};

const kindsForCompanyVisit = {
    NAME: {
        COUNSELING: "カウンセリング",
        AHEAD_SHIFT_CO: '先シフトCO', //TODO
        THIS_SHIFT_CO: '当シフトCO', //TODO
        COUNSELING_1: "オリ①",
        COUNSELING_3: "第3回CO",
        MATCHMAKING_SIMULATION: '見合ｼﾐｭﾚｰｼｮﾝ', //TODO
        DATE_SIMULATION: 'ﾃﾞｰﾄｼﾐｭﾚｰｼｮﾝ', //TODO
        ADVISE: "AD面談",
        COUNSELING_SALES: "CO営業",
        WOMAN_FIRST: "女性初回",
        // CONTRACT: "入会",
        // COUNSELING_2: "第2回CO",
        REMOTE_COUNSELING: "ズームCO",
        // SIMULATION: "シミュレーション",
        // SHIFT_CONTRACT: "シフト入会",
        // COMING_WORK_AFTER_MARRIAGE: "成婚来社",
        USAGE_PROHIBITED: "使用不可",

    },
    VAL: {
        COUNSELING: 14,
        AHEAD_SHIFT_CO: 1002, //TODO
        THIS_SHIFT_CO: 1016, //TODO
        COUNSELING_1: 121,
        COUNSELING_3: 123,
        MATCHMAKING_SIMULATION: 1003, //TODO
        DATE_SIMULATION: 1004, //TODO
        COUNSELING_SALES: 131,
        WOMAN_FIRST: 201,
        ADVISE: 501,

        REMOTE_COUNSELING: 12,
        // SIMULATION: 401,
        // SHIFT_CONTRACT: 102,
        // COMING_WORK_AFTER_MARRIAGE: 1000, //TODO
        // COUNSELING_2: 122,
        // CONTRACT: 101,

        USAGE_PROHIBITED: 1001,

    },
    LIST: [],
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    }
};
for (const [key, value] of Object.entries(kinds.NAME)) {
    kinds.LIST.push({ value: kinds.VAL[key], text: value });
}

for (const [key, value] of Object.entries(kindsForCompanyVisit.NAME)) {
    kindsForCompanyVisit.LIST.push({ value: kindsForCompanyVisit.VAL[key], text: value });
}

const status = {
    LIST: [
        // { text: "全て", value: 0, name: 'ALL' },
        { text: "仮予定", value: 1, name: 'TENTATIVE_PLAN' },
        { text: "予定", value: 2, name: 'PLAN' },
        { text: "実施", value: 3, name: 'IMPLEMENTATION' },
        // { text: "不履行", value: 4, name: 'DEFAULT' },
        { text: "不実施", value: 5, name: 'NOT_IMPLEMENTED' },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getText(value) {
        const type = this.LIST.find(v => v.value == value);
        if (!type) return "";
        return type.text;
    }
}

const notExecutedStatus = {
    LIST: [
        { text: "不履行", value: 4, name: 'DEFAULT' },
        { text: "不実施", value: 5, name: 'NOT_IMPLEMENTED' },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getText(value) {
        const type = this.LIST.find(v => v.value == value);
        if (!type) return "";
        return type.text;
    }
}

const statusSrcMatchingCheck = {
    LIST: [
        // { text: "全て", value: 0, name: 'ALL' },
        { text: "仮予定", value: 1, name: 'TENTATIVE_PLAN' },
        { text: "予定", value: 2, name: 'PLAN' },
        { text: "実施", value: 3, name: 'IMPLEMENTATION' },
        { text: "不履行", value: 4, name: 'DEFAULT' },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    }
}

const statusMatchingLedger = {
    LIST: [
        // { text: "全て", value: 0, name: 'ALL' },
        { text: "仮予定", value: 1, name: 'TENTATIVE_PLAN', color: 'text-red' },
        { text: "予定", value: 2, name: 'PLAN', color: '' },
        { text: "実施", value: 3, name: 'IMPLEMENTATION', color: 'green' },
        // { text: "不履行", value: 4, name: 'DEFAULT', color: 'deep-orange-accent-4' },
        { text: "不履行", value: 5, name: 'NOT_IMPLEMENTED', color: 'black text-white' },
        { text: "前日確済", value: -1, name: 'CONFIRM_BEFORE', color: 'cyan' }
    ],
    getValue(value, color) {
        const type = this.LIST.find(v => v.value == value);
        if (!type) return "";
        if (color) return type.color
        return type.text;
    }
}

const statusMatchingLedgerV2 = {
    LIST: [
        // { text: "全て", value: 0, name: 'ALL' },
        { text: "仮予定", value: 1, name: 'TENTATIVE_PLAN', color: 'text-red' },
        { text: "予定", value: 2, name: 'PLAN', color: '' },
        { text: "実施", value: 3, name: 'IMPLEMENTATION', color: 'green' },
        { text: "不履行", value: 4, name: 'DEFAULT', color: 'black text-white' },
        { text: "不履行", value: 5, name: 'NOT_IMPLEMENTED', color: 'black text-white' },
        { text: "前日確済", value: -1, name: 'CONFIRM_BEFORE', color: 'cyan' }
    ],
    getValue(value, color) {
        const type = this.LIST.find(v => v.value == value);
        if (!type) return "";
        if (color) return type.color
        return type.text;
    },
    getValueByText(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    }
}

const statusOrtherHistory = {
    LIST: [
        { text: "予定", value: 2, name: 'PLAN' },
        { text: "実施", value: 3, name: 'IMPLEMENTATION' },
        { text: "不履行", value: 4, name: 'DEFAULT' },
        { text: "仮予定", value: 1, name: 'TENTATIVE_PLAN' },
        { text: "不在", value: 5, name: 'NOT_IMPLEMENTED' },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    }
}


const statusDefault = {
    LIST: [
        { text: "仮予定", value: 1, name: 'TENTATIVE_PLAN' },
        { text: "予定", value: 2, name: 'PLAN' },
        { text: "実施", value: 3, name: 'IMPLEMENTATION' },
        { text: "不履行", value: 4, name: 'DEFAULT' },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getText(value) {
        const type = this.LIST.find(v => v.value == value);
        if (!type) return "";
        return type.text;
    }
}

const shifts = [
    { label: "なし", value: 0 },
    { label: "あり", value: 1 },
];

const statusPayments = [
    { label: "入金済", value: true },
    { label: "未納", value: false },
];

const resultTELs = [
    { label: "済", value: true },
    { label: "未", value: false },
];

const result = [
    { label: "◯", value: true },
    { label: "×", value: false },
];
const femaleMembership = 9999

const kindTorikumis = [
    { label: execKind.NAME.TO_CALL, value: execKind.VAL.TO_CALL },
    { label: execKind.NAME.FROM_CALL, value: execKind.VAL.FROM_CALL },
    { label: execKind.NAME.EMAIL, value: execKind.VAL.EMAIL },
    { label: execKind.NAME.RECEIVE_EMAIL, value: execKind.VAL.RECEIVE_EMAIL },
    { label: execKind.NAME.OK_CALL, value: execKind.VAL.OK_CALL },
    { label: execKind.NAME.NG_CALL, value: execKind.VAL.NG_CALL },
    { label: execKind.NAME.AUTO_CALL, value: execKind.VAL.AUTO_CALL },
    { label: execKind.NAME.OTHER, value: execKind.VAL.OTHER },
    { label: execKind.NAME.START_DATING, value: execKind.VAL.START_DATING },
    { label: execKind.NAME.RELATIONSHIP_BREAK, value: execKind.VAL.RELATIONSHIP_BREAK },
    // { label: "訪問", value: execKind.VAL.VISIT_COUNSELING },
    { label: execKind.NAME.MARRIAGE, value: execKind.VAL.MARRIAGE },
    { label: execKind.NAME.CONTRACT, value: execKind.VAL.CONTRACT },
    { label: execKind.NAME.SHIFT_CONTRACT, value: execKind.VAL.SHIFT_CONTRACT },
    { label: execKind.NAME.FEMALE_MEMBERSHIP, value: execKind.VAL.FEMALE_MEMBERSHIP },
    { label: execKind.NAME.MINI_TEA_CONTAINER, value: execKind.VAL.MINI_TEA_CONTAINER },
    { label: execKind.NAME.EVENT, value: execKind.VAL.EVENT },
    { label: execKind.NAME.SEMINAR, value: execKind.VAL.SEMINAR },
];

const kindsForPartnerSelection = {
    NAME: {
        SELECT_MATCH: "お相手選び",
        COUNSELING_2: "第2回CO",
        SOLO_INTRODUCTION: "お申込み紹介",
    },
    VAL: {
        SELECT_MATCH: 111,
        COUNSELING_2: 122,
        SOLO_INTRODUCTION: 1018,
    },
    LIST: [],
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    }
};

for (const [key, value] of Object.entries(kindsForPartnerSelection.NAME)) {
    kindsForPartnerSelection.LIST.push({ value: kindsForPartnerSelection.VAL[key], text: value });
}
const NOT_MEMBER_CUSTOMER = 999999999;
const MEMBER_CONNECT = 999999998;

const TYPE_FORM_NAME = {
    COMPANY_VISIT_INPUT: '来社入力',
    IN_HOUSE_MATCH: '自社見合',
    CONNECT_ARRANGEMENT: '連盟見合',
    DATE_INPUT: 'デート',
    INPUT_PARTNER_SELECTION: 'お相手選び入力',
    OTHER_HISTORY_TABLE_INPUT: 'その他経緯表入力',

}

const TYPE_FORM = {
    COMPANY_VISIT_INPUT: 1,
    IN_HOUSE_MATCH: 2,
    CONNECT_ARRANGEMENT: 3,
    DATE_INPUT: 4,
    INPUT_PARTNER_SELECTION: 5,
    OTHER_HISTORY_TABLE_INPUT: 6,
}

const individualResults = {
    LIST: [
        { label: '〇', value: 2 },
        { label: '✖', value: 3 },
        { label: '△', value: 4 },
        { label: '〇1', value: 5 },
        { label: '〇2', value: 6 },
        { label: '〇3', value: 7 },
        { label: '〇4', value: 8 },
        { label: '〇5', value: 9 },
        { label: '再〇', value: 10 },
        { label: '再✖', value: 11 },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.label;
    }
}

const inHouseAndConnectResults = {
    LIST: [
        { label: '〇', value: true },
        { label: '✖', value: false },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.label;
    }
}

const opponentResults = {
    LIST: [
        { label: '〇', value: 2 },
        { label: 'お断り', value: 3 },
        { label: '考える', value: 4 },
        { label: '未紹介', value: 5 },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.label;
    }
}

const bloodTypes = {
    LIST: [
        { label: '不明', value: 1 },
        { label: 'A', value: 2 },
        { label: 'B', value: 3 },
        { label: 'O', value: 4 },
        { label: 'AB', value: 5 },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.label;
    }
}

const isChangeJobOptions = {
    LIST: [
        { label: '有り', value: true },
        { label: '無し', value: false },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "無し";
        return type.label;
    }
}

const paymentMethodOptions = {
    LIST: [
        { label: '振込', value: 1 },
        { label: '持参', value: 2 },
        { label: 'カード', value: 3 },
        { label: 'ローン（アルファノート）', value: 4 },
        { label: 'ローン（AGペイ）', value: 5 },
        { label: '自社分割', value: 6 },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.label;
    }
}

const proofOfDocuments = {
    LIST: [
        { label: '運転免許証', value: 1 },
        { label: '他', value: 4 },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.label;
    }
}

const statusShiftNegotiations = {
    LIST: [
        { text: 'シフト①', value: 1, name: 'SHIFT_1' },
        { text: 'シフト②', value: 2, name: 'SHIFT_2' },
        { text: 'シフト③', value: 3, name: 'SHIFT_3' },
        { text: 'シフト④', value: 4, name: 'SHIFT_4' },
        { text: 'シフト⑤', value: 5, name: 'SHIFT_5' },
        { text: '退会手続き待ち', value: 0, name: 'EXIT_WAIT' },
    ],
    getValue(text) {
        const type = this.LIST.find(v => v.text == text);
        if (!type) return "";
        return type.value;
    },
    getName(val) {
        const type = this.LIST.find(v => v.value == val);
        if (!type) return "";
        return type.text;
    }
}

const FUKUOKA_MALE = {
    id: 1000000067,
    name: "福岡男性 未定"
}

const HIROSHIMA_MALE = {
    id: 1000000075,
    name: "広島男性 未定"
}

export default {
    GENDER: gender,
    BLOOD_TYPE: bloodType,
    FINAL_EDUCATION: finalEducation,
    EXEC_KIND: execKind,
    CONNECT_FLAG: connectFlag,
    EXIT_REASON: exitReason,
    KINDS: kinds,
    STATUS: status,
    STATUS_ORTHER_HISTORY: statusOrtherHistory,
    NOT_EXECUTED_STATUS: notExecutedStatus,
    SHIFTS: shifts,
    STATUS_PAYMENTS: statusPayments,
    RESULT_TELS: resultTELs,
    KIND_TORIKUMIS: kindTorikumis,
    NOT_MEMBER_CUSTOMER,
    FEMALE_MEMBERSHIP: femaleMembership,
    TYPE_FORM_NAME,
    MEMBER_CONNECT,
    KINDS_FOR_COMPANY_VISIT: kindsForCompanyVisit,
    RESULT: result,
    STATUS_DEFAULT: statusDefault,
    KINDS_FOR_PARTNER_SELECTION: kindsForPartnerSelection,
    TYPE_FORM,
    INDIVIDUAL_RESULTS: individualResults,
    IN_HOUSE_AND_CONNECT_RESULTS: inHouseAndConnectResults,
    OPPONENT_RESULTS: opponentResults,
    STATUS_MATCHING_LEDGER_V2: statusMatchingLedgerV2,
    STATUS_SRC_MATCHING_CHECK: statusSrcMatchingCheck,
    STATUS_MATCHING_LEDGER: statusMatchingLedger,
    BLOOD_TYPES: bloodTypes,
    IS_CHANGE_JOB_OPTIONS: isChangeJobOptions,
    PROOF_OF_DOCUMENTS: proofOfDocuments,
    PAYMENT_METHOD_OPTIONS: paymentMethodOptions,
    FUKUOKA_MALE,
    HIROSHIMA_MALE,
    STATUS_SHIFT_NEGOTIATIONS: statusShiftNegotiations,
};
